import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = createContext({ settings: {}, content: {}, loading: true });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const [s, c] = await Promise.all([api.get("/settings"), api.get("/content")]);
      setSettings(s.data || {});
      setContent(c.data || {});
    } catch (e) {
      // keep defaults
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, content, loading, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export function waLink(number, message) {
  const clean = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(message || "")}`;
}

export function telLink(phone) {
  return `tel:${(phone || "").replace(/\s/g, "")}`;
}
